import * as React from 'react';

/** Touch / no-hover devices report `(hover: none)` for their primary pointer. */
const NO_HOVER_QUERY = '(hover: none)';

/**
 * Returns `true` when the primary pointer cannot hover (touch devices).
 *
 * Defaults to `false` (assume hover) on the server and first render so SSR
 * hydration stays consistent; updates after mount. Guards `matchMedia` so it
 * is a no-op under jsdom, which does not implement it.
 */
export function useNoHoverPointer(): boolean {
  const [noHover, setNoHover] = React.useState(false);

  React.useEffect(() => {
    if (
      typeof window === 'undefined' ||
      typeof window.matchMedia !== 'function'
    ) {
      return;
    }

    const mql = window.matchMedia(NO_HOVER_QUERY);
    setNoHover(mql.matches);

    const handler = (e: MediaQueryListEvent) => setNoHover(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return noHover;
}
